<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="vs-sidebar--item"
    :class="[
      { 'vs-sidebar-item-active': activeLink },
      { 'disabled-item pointer-events-none': isDisabled },
    ]"
  >

    <!-- <a
        v-else-if="routeName && routeName === 'org-activity'"
        href="#"
        class="flex items-center"
        @click.stop="activeActivitySidebar = !activeActivitySidebar; fetchOrgActivityLogData()"
      >
          <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
          <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />
          <slot />
      </a> -->

    <router-link
      tabindex="-1"
      v-if="routeName"
      exact
      :class="[{ 'router-link-active': activeLink }]"
      :to="{ name: routeName }"
      :target="target"
    >
      <vs-icon
        v-if="!featherIcon"
        color="white"
        size="25px"
        :icon-pack="iconPack"
        :icon="icon"
      />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
    </router-link>

    <a v-else :target="target" :href="href" tabindex="-1">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
    </a>

    <!--  Activity Sidebar -->
    <!-- <activity :active="activeActivitySidebar" :activityLogData="activityLogData" @closeActivitySidebar="closeActivitySidebar" /> -->
  </div>
</template>

<script>
import Activity from "../Activity/Main.vue";
import constants from "@/constants.js";

export default {
  name: "v-nav-menu-item",
  props: {
    routeName: { type: String, default: "org-home" },
    icon: { type: String, default: "" },
    iconSmall: { type: Boolean, default: false },
    iconPack: { type: String, default: "material-icons" },
    href: { type: [String, null], default: "#" },
    to: { type: [String, Object, null], default: null },
    slug: { type: String, default: null },
    index: { type: [String, Number], default: null },
    featherIcon: { type: Boolean, default: true },
    target: { type: String, default: "_self" },
    isDisabled: { type: Boolean, default: false },
    isVerticalNavReduced: { type: Boolean, default: false },
  },
  components: { Activity },
  data() {
    return {
      constants,
      activeActivitySidebar: false,
      activityLogData: [],
    };
  },
  computed: {
    activeLink() {
      return this.to == this.$route.path ||
        (this.$route.meta.parent == this.slug && this.to)
        ? true
        : false;
    },
    accessToken() {
      return this.$store.state.auth.accessToken;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  methods: {
    closeActivitySidebar() {
      this.activeActivitySidebar = false;
    },
    async fetchOrgActivityLogData() {
      try {
        if (this.orgData._id) {
          this.activityLogData = await this.$store.dispatch(
            "organization/fetchOrgActivityLogData",
            { organizationId: this.orgData._id }
          );
        }
      } catch (err) {
        throw err;
      }
    },
  },
};
</script>

